__turbopack_context__.v({
  "action": "efjqVG_action",
  "content": "efjqVG_content",
  "limitWidth": "efjqVG_limitWidth",
});
